/** Used mostly to trigger css transition after DOM append */
const reflow = (node?: HTMLElement | null): number => {
  node = node ?? document.body;
  return node.offsetWidth;
};

export default reflow;
